import { styleSuccesBlock } from './styleSuccesBlock'

const SuccesBlock = () => {
    return (
        <SuccessWrapperSC>
            <SuccessTitleSC>Готово!</SuccessTitleSC>
            <SuccessDescrSC>
                Отправили на Email письмо с информацией
            </SuccessDescrSC>
        </SuccessWrapperSC>
    )
}

const { SuccessTitleSC, SuccessDescrSC, SuccessWrapperSC } = styleSuccesBlock()

export default SuccesBlock
